module.exports = __webpack_public_path__ + "static/step_2.c50427f3.png";